import { render, staticRenderFns } from "./Videotrack.vue?vue&type=template&id=0c1e9080&scoped=true&"
import script from "./Videotrack.vue?vue&type=script&lang=js&"
export * from "./Videotrack.vue?vue&type=script&lang=js&"
import style0 from "./Videotrack.vue?vue&type=style&index=0&id=0c1e9080&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1e9080",
  null
  
)

export default component.exports